export const USER_TOKEN_STORAGE_NAME = 'authorization'
export const APPLICATION_KEY_STORAGE_NAME = 'appkey'
export const PERSONALIZATION_KEY_STORAGE_NAME = 'personalization'
